// extracted by mini-css-extract-plugin
module.exports = {"pager":"Pager_pager__2YZZ5","spacer":"Pager_spacer__3HB8b","link":"Pager_link__ZyzcP"};